/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import moment from "moment";

import { ROUTES, useMediaQueries } from "../../../../shared";
import DayRangeFilter from "../../../DayRangeFilter/DayRangeFilter";
import FilterButton from "../../components/FilterButton";
import FilterMenu from "../../components/FilterMenu";
import { useFilters } from "../../hooks";
import { useStyles } from "../../styles";

import DriverFilesFilters from "./DriverFilesFilters";
import VehicleFilesFilters from "./VehicleFilesFilters";

interface FilesFiltersProps {
  route: ROUTES;
}

const FilesFilters = ({ route }: FilesFiltersProps) => {
  const { anchorEl, handleOpenMenu, handleCloseMenu, isPartOfFilesFilterMenu } =
    useFilters(route);

  const { fromMd } = useMediaQueries();
  const { filtersMainBlock, separateFilterDropdown, filtersListBlock } =
    useStyles();

  const minDate = moment().subtract(24, "months");

  return (
    <div css={css(filtersMainBlock)} data-testid="files-filters">
      {!isPartOfFilesFilterMenu() && (
        <div css={css(separateFilterDropdown)}>
          <DayRangeFilter route={route} minDate={minDate} />
        </div>
      )}

      <FilterButton
        route={route}
        onOpen={handleOpenMenu}
        hasLoadingCustomStyle
        hasMoreFilters
        moreFiltersBreakPoint={fromMd}
      />
      <FilterMenu
        isOpen={Boolean(anchorEl)}
        onClose={handleCloseMenu}
        anchorEl={anchorEl}
        hasMoreFilters
        moreFiltersBreakPoint={fromMd}
      >
        <div css={css(filtersListBlock)}>
          {isPartOfFilesFilterMenu() && (
            <DayRangeFilter route={ROUTES.VehicleFiles} minDate={minDate} />
          )}

          {route === ROUTES.VehicleFiles && <VehicleFilesFilters />}

          {route === ROUTES.DriverFiles && <DriverFilesFilters />}
        </div>
      </FilterMenu>
    </div>
  );
};

export default FilesFilters;
